// Dev only: browser wallet extensions (Phantom/MetaMask) fight over injecting
// window.ethereum and throw on page load. That's not our code, but CRA's
// error overlay catches every window error and blocks the screen with it.
// Swallow errors originating from extension scripts before the overlay sees
// them (capture phase runs ahead of CRA's own listener).
if (process.env.NODE_ENV === 'development') {
  window.addEventListener('error', (e) => {
    if (e.filename?.startsWith('chrome-extension://')) {
      e.stopImmediatePropagation();
    }
  }, true);
}

// REACT_APP_TARGET is fixed at build time, so the bundler drops the branch
// not taken: the web build never contains the Gate 1 trial and vice versa.
if (process.env.REACT_APP_TARGET === 'gate1') {
  window.__GATE1_JS_ENTRY = performance.now();
  require('./gate1/main');
} else {
  require('./main').renderGame();
}
